module.exports = __webpack_public_path__ + "media/assets/icons/thumb_down-bc28342064a6c75f89874ee9313f2fcb.svg";